/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class CostAnomalyGroupingRuleRequest {
    getFixupPrototypeFunction() { return CostAnomalyGroupingRuleRequest.fixupPrototype; }

    static newInstance(model: Partial<CostAnomalyGroupingRuleRequest>): CostAnomalyGroupingRuleRequest {
        let obj = Object.assign(new CostAnomalyGroupingRuleRequest(), model);
        CostAnomalyGroupingRuleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<CostAnomalyGroupingRuleRequest>): CostAnomalyGroupingRuleRequest {
        if (!model) return null;
        return CostAnomalyGroupingRuleRequest.newInstance(<CostAnomalyGroupingRuleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: CostAnomalyGroupingRuleRequest) {
        if (!obj) return;

        models.CostAnomalyGroupingRuleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: CostAnomalyGroupingRuleRequest): boolean {
        Object.setPrototypeOf(obj, CostAnomalyGroupingRuleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.start_date === "string") {
            this.start_date = new Date(<string><any>this.start_date);
        }
        if (typeof this.end_date === "string") {
            this.end_date = new Date(<string><any>this.end_date);
        }
        if (this.filters) {
            models.QueryOperator.fixupPrototype(this.filters);
        }
        if (this.dimension_rule_mappings) {
            for (let val of this.dimension_rule_mappings) {
                models.DimensionRuleMapping.fixupPrototype(val);
            }
        }
    }

    /**
     * specify the start date
     */
    start_date: Date;

    /**
     * specify the end date
     */
    end_date: Date;

    /**
     * Required Anomaly status
     */
    anomaly_status: models.AnomalyStatus;

    /**
     * Optional timezone of the caller
     */
    time_zone: string;

    /**
     * Query expression to filter line items
     */
    filters: models.QueryOperator;

    /**
     * Billing Currency
     */
    currency: models.Currency;

    /**
     * List of dimensions with their respective grouping rule IDs
     */
    dimension_rule_mappings: Array<models.DimensionRuleMapping>;

    /**
     * Records based on the actual metric that is used during anomaly detection
     */
    billing_source: string;

}
